import classNames from "classnames";
import React from "react";

export type CaTableHeadProps = React.DetailedHTMLProps<
  React.ThHTMLAttributes<HTMLTableCellElement>,
  HTMLTableCellElement
>;

function CaTableHead({ className, ...props }: CaTableHeadProps) {
  return (
    <th
      className={classNames(
        "py-5 px-6 text-left align-middle font-semibold uppercase text-sm text-dark-neutral-1 font-sans-serif",
        className,
      )}
      {...props}
    />
  );
}

export default CaTableHead;
